module.exports = __webpack_public_path__ + "img/Nice.bcd1be4c.svg";